<template>
  <div class="page">
    <div class="nav" :style="{ backgroundColor: `rgba(231, 240, 255, ${opacity})` }">
      <div class="nav_con">
        <div class="logo">
          <img src="../../images/logo.png" alt="Logo" class="logo-img" />
          <span class="logo-text">閃充寶</span>
        </div>
        <div class="nav-bar">
          <p @click="scrollToAnchor('banner')" class="nav-item">產品介紹</p>
          <p @click="scrollToAnchor('cpjs')" class="nav-item">市場規模</p>
          <p @click="scrollToAnchor('hzfw')" class="nav-item">合作服務</p>
          <p @click="scrollToAnchor('download')" class="nav-item">下載中心</p>
        </div>
      </div>
    </div>
    <div class="banner_box" id="banner">
      <div class="banner_con">
        <h2>手機沒電不用慌</h2>
        <h2>隨地借電更方便</h2>
        <div class="label">
          <div class="li">
            <img src="../../images/banner_icon1.png" alt="">
            <p>隨身能量 隨時續航</p>
          </div>
          <div class="li">
            <img src="../../images/banner_icon2.png" alt="">
            <p>極速快充 即刻滿格</p>
          </div>
          <div class="li">
            <img src="../../images/banner_icon3.png" alt="">
            <p>安全快充，放心使用</p>
          </div>
        </div>
        <p class="desc">[閃充寶] 深耕便攜儲能領域，專注充電寶研發、生產與銷售。依託專業團隊攻克快充與安全技術，採用優質電芯與精密工藝，打造覆蓋日常、差旅、商用的全場景產品。秉持 “科技賦能便捷生活” 理念，以安全高效的產品與完善服務，爲全球用戶提供可靠移動充電解決方案。</p>
      </div>
    </div>
    <div class="cj">
      <div class="item">
        <img src="../../images/b01.png" alt="" srcset="">
        <div class="box">
          <h4>使命</h4>
          <p>賦能移動生活, 電力永不缺席</p>
        </div>
      </div>
      <div class="item">
        <img src="../../images/b02.png" alt="" srcset="">
        <div class="box">
          <h4>願景</h4>
          <p>構建全民共享充電生態</p>
        </div>
      </div>
      <div class="item">
        <img src="../../images/b03.png" alt="" srcset="">
        <div class="box">
          <h4>價值觀</h4>
          <p>品質爲先, 合作共贏, 持續精進</p>
        </div>
      </div>
    </div>
    <div  id="cpjs"></div>
    <div class="sc_box">
      <div class="sc">
        <h2>參與閃充寶共掘萬億市場</h2>
        <div class="tj">
          <div class="li">
            <img src="../../images/sc1.png" alt="">
            <div class="text">
              <h3>4000+</h3>
              <p>終端用戶數</p>
            </div>
          </div>
          <div class="li">
            <img src="../../images/sc2.png" alt="">
            <div class="text">
              <h3>4000+</h3>
              <p>服務顧客數</p>
            </div>
          </div>
          <div class="li">
            <img src="../../images/sc3.png" alt="">
            <div class="text">
              <h3>4000+</h3>
              <p>商戶入駐數</p>
            </div>
          </div>
          <div class="li">
            <img src="../../images/sc4.png" alt="">
            <div class="text">
              <h3>4000+</h3>
              <p>騎手入駐數</p>
            </div>
          </div>
        </div>
        <div class="info">
          <div class="item">
            <img src="../../images/sc_icon1.png" alt="">
            <div class="text">
              <h3>隨身滿電隨行</h3>
              <p>小體積藏大能量，通勤差旅告別電量焦慮</p>
            </div>
          </div>
          <div class="item">
            <img src="../../images/sc_icon2.png" alt="">
            <div class="text">
              <h3>快充無需久候</h3>
              <p>兼容多協議極速補能，30 分鐘煥活設備</p>
            </div>
          </div>
          <div class="item">
            <img src="../../images/sc_icon3.png" alt="">
            <div class="text">
              <h3>安全續航雙在線</h3>
              <p>優質電芯 + 智能防護，放心使用續航無憂</p>
            </div>
          </div>
          <div class="item">
            <img src="../../images/sc_icon4.png" alt="">
            <div class="text">
              <h3>全場景電力搭檔</h3>
              <p>適配日常 / 商用 / 戶外，隨時隨地電力加持</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div  id="hzfw"></div>
    <div class="hz_box">
      <div class="hz_con">
        <h2>合作優勢</h2>
        <div class="ul">
          <div class="li">
            <img src="../../images/hz1.png" alt="">
            <h4>豐厚返利</h4>
            <p>合作即享 返利實時到賬</p>
            <p>多推多賺 上不封頂</p>
            <p>無套路返利 共贏無憂</p>
          </div>
          <div class="li">
            <img src="../../images/hz2.png" alt="">
            <h4>體系化培訓</h4>
            <p>從零到精 階梯式教學</p>
            <p>實操乾貨 快速上手</p>
            <p>專屬指導 全程護航</p>
          </div>
          <div class="li">
            <img src="../../images/hz3.png" alt="">
            <h4>服務支持</h4>
            <p>24 小時在線答疑 快速響應</p>
            <p>設備運維保障 售後及時</p>
            <p>專屬顧問對接 貼心護航</p>
          </div>
          <div class="li">
            <img src="../../images/hz4.png" alt="">
            <h4>市場支持</h4>
            <p>物料補貼 降低運營成本</p>
            <p>營銷方案 精準引流獲客</p>
            <p>區域扶持 全程專人對接</p>
          </div>
          <div class="li">
            <img src="../../images/hz5.png" alt="">
            <h4>低門檻入局</h4>
            <p>無需高額投入 快速啓動</p>
            <p>流程簡化高效 省心入駐</p>
            <p>零經驗可做 全程指導</p>
          </div>
        </div>
      </div>
    </div>
    <div class="lc">
      <h2>閃充寶合作伙伴申請合作流程</h2>
      <div class="ul">
        <div class="li">
          <img src="../../images/lc1.png" alt="" srcset="">
          <div class="text">
            <h3>01</h3>
            <p>提交申請</p>
          </div>
        </div>
        <img src="../../images/lc_arrow.png" alt="">
        <div class="li">
          <img src="../../images/lc1.png" alt="" srcset="">
          <div class="text">
            <h3>02</h3>
            <p>審覈資料</p>
          </div>
        </div>
        <img src="../../images/lc_arrow.png" alt="">
        <div class="li">
          <img src="../../images/lc1.png" alt="" srcset="">
          <div class="text">
            <h3>03</h3>
            <p>洽談合作</p>
          </div>
        </div>
        <img src="../../images/lc_arrow.png" alt="">
        <div class="li">
          <img src="../../images/lc1.png" alt="" srcset="">
          <div class="text">
            <h3>04</h3>
            <p>簽約合作</p>
          </div>
        </div>
      </div>
    </div>
    <div  id="download"></div>
    <div class="download">
      <div class="d_con">
        <div class="address">
          <h2>閃充寶APP下載</h2>
          <a href="">
            <img src="../../images/android.png" alt="">
            <p>安卓下載</p>
          </a>
          <a href="">
            <img src="../../images/ios.png" alt="">
            <p>iOS下載</p>
          </a>
        </div>
        <div class="info">
          <h3>極速快充 + 靈活歸還，就用這款充電 APP！</h3>
          <div class="block"></div>
          <div class="ul">
            <div class="li">
              <img src="../../images/dl_icon1.png" alt="">
              <p>掃碼即借,電量即刻到賬</p>
            </div>
            <div class="li">
              <img src="../../images/dl_icon2.png" alt="">
              <p>一鍵找寶，告別手機斷電焦慮！</p>
            </div>
            <div class="li">
              <img src="../../images/dl_icon3.png" alt="">
              <p>免押租借 + 導航找樁，充電超省心！</p>
            </div>
            <div class="li">
              <img src="../../images/dl_icon4.png" alt="">
              <p>手機沒電不用慌，APP 在手電力強～</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShanchongbaoPage',
  data() {
    return {
      opacity: 0, // 初始透明度为0
      scrollMax: 466 // 滚动阈值：80px
    }
  },
  mounted() {
    // 监听滚动触发动画
    this.initScrollAnimation();
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    // 组件销毁时移除监听，避免内存泄漏（Vue 2 用destroyed钩子）
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    scrollToAnchor(id) {
      const target = document.getElementById(id);
      if (target) {
        // 核心：线性平滑滚动
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
      }
    },
    handleScroll() {
      // 获取页面滚动距离（兼容所有浏览器）
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      
      // 计算透明度：0~80px区间内从0平滑到1，超过80px固定为1
      if (scrollTop <= 0) {
        this.opacity = 0
      } else if (scrollTop >= this.scrollMax) {
        this.opacity = 1
      } else {
        // 核心逻辑：滚动距离 / 阈值 = 透明度比例
        this.opacity = scrollTop / this.scrollMax
      }
    },
    initScrollAnimation() {
      const animateElements = document.querySelectorAll(
        '.animate-fade-in, .animate-scale, .animate-slide-up, .animate-slide-right'
      );
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translate(0) scale(1)';
          }
        });
      }, { threshold: 0.1 });
      
      animateElements.forEach(el => {
        el.style.opacity = '0';
        observer.observe(el);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/* 基础布局 */
.page{
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  .nav{
    width: 100%;
    height: 80px;
    position: fixed;
    top: 0;
    z-index: 999;
    display: flex;
    justify-content: center;
    .nav_con{
      width: 100%;
      max-width: 1280px;
      box-sizing: border-box;
      padding: 0 94px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .logo{
        display: flex;
        align-items: center;
        .logo-img{
          height: 45px;
        }
        .logo-text{
          font-size: 32px;
          color: #3E4045;
          margin-left: 10px;
          font-weight: bold;
        }
      }
      .nav-bar{
        display: flex;
        align-items: center;
        .nav-item{
          margin-left: 30px;
          font-size: 16px;
          color: #0D0F11;
          text-decoration: none;
          transition: 0.5s;
          cursor: pointer;
          &:hover{
            font-weight: bold;
          }
        }
      }
    }
  }
  .banner_box{
    width: 100%;
    height: 466px;
    
    background: url('../../images/banner_bg.png') no-repeat center;
    background-size: 1088px 466px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #E7F0FF;
    .banner_con{
      width: 100%;
      max-width: 1280px;
      height: 100%;
      // background-color: #E7F0FF;
      box-sizing: border-box;
      padding: 0 94px;
      display: flex;
      flex-direction: column;
      justify-content: center;  
      align-items: flex-start;
      h2{
        font-size: 38px;
        line-height: 1.5;
        font-weight: bold;
        color: #1C2023;
      }
      .label{
        display: flex;
        align-items: center;
        margin-top: 6px;
        .li{
          display: flex;
          align-items: center;
          margin-right: 24px;
          img{
            height: 16px;
          }
          p{
            margin-left: 6px;
            font-size: 14px;
            color: #4F5867;
            line-height: 1.5;
          }
        }
      }
      .desc{
        width: 532px;
        margin-top: 18px;
        font-size: 14px;
        line-height: 1.5;
        color: #4F5867;
        text-align: left;
      }
    }
  }
  .cj{
    margin-top: 80px;
    display: flex;
    justify-content: center;
      .item{
        width: 274px;
        display: flex;
        flex-direction: column;
        align-items: center;
        
        img{
          width: 100%;
        }
        .box{
          width: 100%;
          height: 82px;
          background: url('../../images/b_bg.png') no-repeat center;
          background-size: cover;
          display: flex;
          flex-direction: column;
          box-sizing: border-box;
          justify-content: center;
          align-items: flex-start;
          padding-left: 28px;
          h4{
            font-size: 18px;
            line-height: 27px;
            color: #fff;
            font-weight: bold;
          }
          p{
            margin-top: 6px;
            font-size: 14px;
            color: #fff;
            line-height: 1.5;
            font-weight: bold;
          }
      }
    }
    .item+.item{
      margin-left: 36px;
    }
  }
  .sc_box{
    width: 100%;
    margin-top: 80px;
    background-color: #F9FBFE;
    display: flex;
    justify-content: center;
    padding-top: 37px;
    paddbing-bottom: 60px;
    .sc{
      width: 100%;
      max-width: 900px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      h2{
        font-size: 26px;
        line-height: 1.5;
        color: #1D2229;
        font-weight: bold;
      }
      .tj{
        width: 100%;
        margin-top: 55px;
        display: flex;
        justify-content: space-between;
        .li{
          display: flex;
          align-items: center;
          img{
            height: 52px;
          }
          .text{
            margin-left: 12px;
            height: 52px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: self-start;
            h3{
              font-size: 28px;
              color: #202124;
              font-weight: bold;
            }
            p{
              font-size: 12px;
              color: #202124;
              line-height: 1.5;
            }
          }
        }
      }
      .info{
        margin-top: 57px;
        width: 100%;
        height: 274px;
        display: flex;
        flex-wrap: wrap;
        box-sizing: border-box;
        border: 2px #C5DDFF solid;
        border-radius: 12px;
        background: linear-gradient( 134deg, #FBFDFF 0%, #F6F9FF 100%);
        .item{
          width: 50%;
          height: 50%;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          padding-left: 38px;
          img{
            width: 30px;
            height: 30px;
          }
          .text{
            margin-left: 10px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            h3{
              font-size: 18px;
              line-height: 1.5;
              color: #0B2555;
              font-weight: bold;
            }
            p{
              margin-top: 6px;
              font-size: 14px;
              line-height: 1.5;
              color: #0B2555;
            }
          }
        }
        .item:nth-child(2n){
          border-left: 1px #E5F0FF solid;
        }
        .item:nth-child(n+3){
          border-top: 1px #E5F0FF solid;
        }
      }
    }
  }
  .hz_box{
    width: 100%;
    margin-top: 60px;
    padding-top: 70px;
    padding-bottom: 86px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: linear-gradient( 134deg, #F2F5FC 0%, #ECFAFD 100%);
    .hz_con{
      width: 100%;
      max-width: 900px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      h2{
        font-size: 26px;
        line-height: 1.5;
        color: #202124;
        font-weight: bold;
      }
      .ul{
        width: 100%;
        margin-top: 29px;
        display: flex;
        justify-content: space-between;
        .li{
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          background: linear-gradient( 180deg, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0.5) 100%);
          border: 1px #E5F0FF solid;
          border-radius: 10px;
          box-sizing: border-box;
          padding: 30px 0;
          img{
            height: 50px;
          }
          h4{
            margin-top: 12px;
            font-size: 16px;
            line-height: 1.5;
            color: #202124;
            font-weight: bold;
          }
          p{
            margin-top: 4px;
            font-size: 12px;
            line-height: 1.5;
            color: #202124;
          }
        }
        .li+.li{
          margin-left: 19px;
        }
      }
    }
  }
  .lc{
      width: 100%;
      max-width: 900px;
      padding: 64px 0;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      h2{
        font-size: 26px;
        line-height: 1.5;
        color: #202124;
        font-weight: bold;
      }
      .ul{
        width: 100%;
        margin-top: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .li{
          display: flex;
          align-items: center;
         
          img{
            height: 60px;
          }
          .text{
            margin-left: 10px;
            height: 60px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;

            h3{
              font-size: 24px;
              line-height: 1.5;
              color: #006CFF;
              font-weight: bold;
            }
            p{
              font-size: 16px;
              line-height: 1.5;
              color: #202124;
            }
          }
          
        }
        &>img{
          width: 36px;
          height: 36px;
        }
      }
    }
  .download{
    width: 100%;
     background: url('../../images/dl_bg.png') no-repeat center;background-size: 1920px 620px;
     background-position: center top;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 126px;
    padding-bottom: 56px;
    .d_con{
      width: 100%;
      max-width: 900px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      .address{
        display: flex;
        align-items: center;
        h2{
          font-size: 22px;
          line-height: 1.5;
          color: #1C1F1B;
          font-weight: bold;
        }
        a{
          margin-left: 12px;
          width: 112px;
          height: 42px;
          border-radius: 4px;
          border: 1px #1C1F1B solid;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: 0.4s;
          img{
            height: 20px;
          }
          p{
            margin-left: 10px;
            font-size: 14px;
            color: #1C1F1B;
          }
        }
        a:hover{
          background-color: rgba(255, 255, 255, 1);
          box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);
        }
      }
      .info{
        width: 100%;
        height: 380px;
        margin-top: 20px;
        background: url('../../images/dowon_bg.png') no-repeat center;background-size: 900px 380px;
        background-position: center top;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 80px 30px;
        h3{
          font-size: 20px;
          line-height: 1.5;
          color: #1C1F1B;
          font-weight: bold;
        }
        .block{
          width: 22px;
          height: 3px;
          background-color: #305DFF;
          margin-top: 37px;
        }
        .ul{
          margin-top: 63px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .li{
            display: flex;
            align-items: center;
            margin-top: 5px;
            img{
              height: 12px;
            }
            p{
              margin-left: 10px;
              font-size: 14px;
              line-height: 1.5;
              color: #5D5D5D;
            }
          }
        }
      }
    }
  }
}

/* CSS动画 */
.animate-float {
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}

.animate-fade-in {
  transition: all 0.8s ease;
  transform: translateY(20px);
}

.animate-scale {
  transition: all 0.8s ease;
  transform: scale(0.9);
}

.animate-slide-up {
  transition: all 0.8s ease;
  transform: translateY(30px);
}

.animate-slide-right {
  transition: all 0.8s ease;
  transform: translateX(-20px);
}
</style>